import { render, staticRenderFns } from "./jobTab2.vue?vue&type=template&id=773cfe96&scoped=true&"
import script from "./jobTab2.vue?vue&type=script&lang=js&"
export * from "./jobTab2.vue?vue&type=script&lang=js&"
import style0 from "./jobTab2.vue?vue&type=style&index=0&id=773cfe96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773cfe96",
  null
  
)

export default component.exports